var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7H4.33333M1 7C1 10.3137 3.68629 13 7 13M1 7C1 3.68629 3.68629 1 7 1M4.33333 7H9.66667M4.33333 7C4.33333 10.3137 5.52724 13 7 13M4.33333 7C4.33333 3.68629 5.52724 1 7 1M9.66667 7H13M9.66667 7C9.66667 3.68629 8.47276 1 7 1M9.66667 7C9.66667 10.3137 8.47276 13 7 13M13 7C13 3.68629 10.3137 1 7 1M13 7C13 10.3137 10.3137 13 7 13",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.5c6c7e7f44498aadd852d9cccedb198f.svg";
export { ForwardRef as ReactComponent };